import { render } from "./BusParkParking.vue?vue&type=template&id=396f6964"
import script from "./BusParkParking.vue?vue&type=script&lang=js"
export * from "./BusParkParking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__